import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router';
import { Loader } from '../Loader';
import { MainScreen } from '../MainScreen';
import { SuccessModal } from '../ResultModal';

export const Root: React.FC = () => {
  return (
    <Switch>
      <Route path="/success">
        <Suspense fallback={<Loader />}>
          <SuccessModal />
        </Suspense>
      </Route>

      <Route path="/">
        <MainScreen />
      </Route>
    </Switch>
  );
};
